import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import config from 'constants/config'
import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import { getLocaleUrlRedirect } from 'i18n/util/localeUrl'

export default function LocaleUrlRedirectGuard() {
  const location = useLocation()
  const supportedRegionCodes = useMemo(() => config.regions.map(region => region.code), [])
  const redirect = useMemo(
    () => getLocaleUrlRedirect(`${location.pathname}${location.search}${location.hash}`, supportedRegionCodes),
    [location.pathname, location.search, location.hash, supportedRegionCodes],
  )

  if (!redirect) {
    return null
  }

  return <RedirectWithStatus
    code={redirect.statusCode}
    to={redirect.url}
    withSearchAndHash={false}
  />
}
